export const NativeiOSLink = "https://apps.apple.com/app/id6448315664"
export const NativeAndroidLink = "https://play.google.com/store/apps/details?id=org.circleofa.acimce"